<template>
    <div>
        <div v-if="windowWidth > 1279" class="s_1280">
            <!-- upper menu -->
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-4">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-8">
                    <div class="app navigation">
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>

            <!-- main area -->
            <div class="main app">
                <div class="container-fluid wrapper">
                    <div class="row reg-box">

                        <!-- side bar (TODO: replace with component -->
                        <div class="col-3">
                            <div class="left-bg">
                                <div class="left-links">
                                    <label class="done">Registration</label>
                                    <label class="done">Payment</label>
                                    <label class="active" href="#">Visa Form</label>
                                    <label class="passive" href="#">Documents</label>
                                </div>
                            </div>
                        </div>


                        <!-- working are -->
                        <div class="col-9">
                            <div class="reg-form top98">
                                <form class="k-form" @submit="handleSubmit" novalidate="true" autocomplete="off">
                                    <h2>Application details</h2>

                                    <div class="form-group row">
                                        <label for="surname" class="col-sm-4 col-form-label">1. Surname</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="surname" class="form-control" v-model="model.LastName" @keypress="isLetterOfName($event)" maxlength="40">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="firstname" class="col-sm-4 col-form-label">2. First name</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="firstname" class="form-control" v-model="model.FirstName" @keypress="isLetterOfName($event)" maxlength="50">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="mddlename" class="col-sm-4 col-form-label">3. Miiddle name</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="mddlename" class="form-control" v-model="model.MiddleName" @keypress="isLetterOfName($event)" maxlength="40">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="prevname" class="col-sm-4 col-form-label">4. Previous/Maiden Surname</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="prevname" class="form-control" v-model="model.PrevName" @keypress="isLetterOfName($event)" maxlength="40">
                                        </div>
                                    </div>

                                    <div class="reg-div"></div>

                                    <div class="form-group row">
                                        <label for="brthdate" class="col-sm-4 col-form-label">5. Date of birth</label>
                                        <div class="col-sm-8">
                                            <datepicker v-model="model.BirthDate"
                                                        :name="'dob'"
                                                        class="form-control no-blue"
                                                        :disabled="false"
                                                        :min="minDOB" :max="getToday"
                                                        :label="'Date of Birth'"
                                                        :placeholder="'Date of Birth'"
                                                        :format="'dd/MM/yyyy'"
                                                        :required='true' />
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="nationality" class="col-sm-4 col-form-label">6. Country of Birth</label>
                                        <div class="col-sm-8">
                                            <kendo-combobox v-model="model.BirthCountry"
                                                            :data-source="countries"
                                                            class="form-control no-blue"
                                                            :name="'BirthCountry'"
                                                            id="BirthCountry"
                                                            :placeholder="'Select country of birth...'"
                                                            :data-text-field="'Description'"
                                                            :data-value-field="'Code'"
                                                            :filter="'contains'"
                                                            :required="true"
                                                            @cascade="onBirthCountryChanged"
                                                            :filter-fields="['Description']" />
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="birthplace" class="col-sm-4 col-form-label">7. Place of Birth</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="birthplace" class="form-control" v-model="model.BirthPlace" maxlength="50">
                                        </div>
                                    </div>

                                    <div class="reg-div"></div>

                                    <div class="form-group row">
                                        <label for="passportnum" class="col-sm-4 col-form-label">8. Sex</label>
                                        <div class="col-sm-8">
                                            <kendo-combobox v-model="model.Gender"
                                                            :data-source="genders"
                                                            :name="'Gender'"
                                                            id="gender"
                                                            class="form-control no-blue"
                                                            :placeholder="'Select gender...'"
                                                            :data-text-field="'Description'"
                                                            :data-value-field="'Code'"
                                                            :filter="'contains'"
                                                            :required="true"
                                                            @cascade="onGenderChanged"
                                                            :filter-fields="['Description']" />
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="passportnum" class="col-sm-4 col-form-label">9. Martial status</label>
                                        <div class="col-sm-8">
                                            <kendo-combobox v-model="model.MaritalStatus"
                                                            :data-source="maritalStatuses"
                                                            :name="'Marital Status'"
                                                            id="martStatus"
                                                            class="form-control no-blue"
                                                            :placeholder="'Select marital status...'"
                                                            :data-text-field="'Description'"
                                                            :data-value-field="'Code'"
                                                            :filter="'contains'"
                                                            :required="true"
                                                            @cascade="onMaritalStatusChanged"
                                                            :filter-fields="['Description']" />
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="brthdate" class="col-sm-4 col-form-label">10. Nationality</label>
                                        <div class="col-sm-8">
                                            <kendo-combobox v-model="model.Nationality"
                                                            :data-source="countries"
                                                            :name="'Country'"
                                                            id="nationality"
                                                            class="form-control no-blue"
                                                            :placeholder="'Nationality...'"
                                                            :data-text-field="'Description'"
                                                            :data-value-field="'Code'"
                                                            :filter="'contains'"
                                                            :required="true"
                                                            @cascade="onNationalityChanged"
                                                            :filter-fields="['Description']" />

                                        </div>
                                    </div>

                                    <div class="reg-div"></div>

                                    <div class="form-group row">
                                        <label for="expirydate" class="col-sm-4 col-form-label">11. Type of visa required</label>
                                        <div class="col-sm-2">
                                            <label id="brthdate" class="form-control disabled">{{strVisaCategory}}</label>
                                        </div>
                                        <label for="expirydate" class="col-sm-4 col-form-label">12. Number of Entries</label>
                                        <div class="col-sm-2">
                                            <label id="brthdate" class="form-control disabled">{{strVisaType}}</label>
                                        </div>
                                        <p class="disabled">If you need to change the values of these fields, then you need to create a new application or contact the technical support service</p>
                                    </div>

                                    <div class="reg-div"></div>


                                    <h3>Address in Country of Domicile</h3>

                                    <div class="form-group row">
                                        <label for="vsatype" class="col-sm-4 col-form-label">13. Country</label>
                                        <div class="col-sm-8">
                                            <kendo-combobox v-model="address[0].Country"
                                                            :data-source="countries"
                                                            :name="'Domicile Country'"
                                                            id="domCountry"
                                                            class="form-control no-blue"
                                                            :placeholder="'Select country...'"
                                                            :data-text-field="'Description'"
                                                            :data-value-field="'Code'"
                                                            :filter="'contains'"
                                                            :required="true"
                                                            @cascade="onDomicileCountryChanged"
                                                            :filter-fields="['Description']" />
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="entries" class="col-sm-4 col-form-label">14. Town/Village</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="entries" class="form-control" v-model="address[0].Town" maxlength="100">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="entries" class="col-sm-4 col-form-label">15. Street/Ward</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="entries" class="form-control" v-model="address[0].Street" maxlength="20">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="email" class="col-sm-4 col-form-label">16. Plot/House No.</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="email" class="form-control" v-model="address[0].HouseNo" maxlength="20">
                                        </div>
                                    </div>

                                    <div class="reg-div"></div>

                                    <div class="form-group row">
                                        <label for="email" class="col-sm-4 col-form-label">17. Occupation</label>
                                        <div class="col-sm-8">
                                            <kendo-combobox v-model="model.Occupation"
                                                            :data-source="occupations"
                                                            :name="'Occupation'"
                                                            id="occupation"
                                                            class="form-control no-blue"
                                                            :placeholder="'Select occupation...'"
                                                            :data-text-field="'Description'"
                                                            :data-value-field="'Code'"
                                                            :filter="'contains'"
                                                            :required="true"
                                                            @cascade="onOccupationChanged"
                                                            :filter-fields="['Description']" />

                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="email" class="col-sm-4 col-form-label">18. Qualifications</label>
                                        <div class="col-sm-8">

                                            <kendo-multiselect v-model="qualifications"
                                                               class="form-control"
                                                               :data-source="occupations"
                                                               :data-text-field="'Description'"
                                                               :data-value-field="'Code'"
                                                               :placeholder="'Select qualifications...'"
                                                               :filter="'contains'" />
                                        </div>
                                    </div>

                                    <div class="reg-div"></div>

                                    <h3>Particulars of travel documents which should be submitted with this Application</h3>

                                    <div class="form-group row">
                                        <label for="passno" class="col-sm-4 col-form-label">19. Number</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="passno" class="form-control upper" v-model="model.PassportNo" @keypress="isLetterOfPassportNumber($event)" maxlength="9">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="passplace" class="col-sm-4 col-form-label">20. Place of Issue</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="passplace" class="form-control" v-model="model.PassportIssuePlace" maxlength="25">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="brthdate" class="col-sm-4 col-form-label">21. Issue</label>
                                        <div class="col-sm-8">
                                            <datepicker v-model="model.PassportIssueDate"
                                                        :name="'passIssueDate'"
                                                        class="form-control no-blue"
                                                        :label="'Issue Date'"
                                                        :placeholder="'Issue Date'"
                                                        :format="'dd/MM/yyyy'"
                                                        :required='true' />
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="passExpiry" class="col-sm-4 col-form-label">22. Expiry</label>
                                        <div class="col-sm-8">
                                            <datepicker v-model="model.PassportExpiryDate"
                                                        :name="'passExpiryDate'"
                                                        class="form-control no-blue"
                                                        :min="getToday" :max="getTodayPlus20"
                                                        :label="'Passport Expiry Date'"
                                                        :placeholder="'Passport Expiry Date'"
                                                        :format="'dd/MM/yyyy'"
                                                        :required='true' />
                                        </div>
                                    </div>


                                    <div class="reg-div"></div>

                                    <h2>Host details</h2>
                                    <h3>Host Address in Botswana</h3>

                                    <div class="form-group row">
                                        <label for="bwtown" class="col-sm-4 col-form-label">23. Town/Village</label>
                                        <div class="col-sm-8">
                                            <kendo-combobox v-model="address[1].TownBW"
                                                            :data-source="towns"
                                                            :name="'Domicile Town'"
                                                            id="domTown"
                                                            class="form-control no-blue"
                                                            :placeholder="'Select town/village...'"
                                                            :data-text-field="'Description'"
                                                            :data-value-field="'Code'"
                                                            :filter="'contains'"
                                                            :required="true"
                                                            @cascade="onTownBWChanged"
                                                            :filter-fields="['Description']" />
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="bwstr" class="col-sm-4 col-form-label">24. Street/Ward</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="bwstr" class="form-control" v-model="address[1].Street" maxlength="20">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="bwhouseno" class="col-sm-4 col-form-label">25. Plot/House No.</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="bwhouseno" class="form-control" v-model="address[1].HouseNo" maxlength="20">
                                        </div>
                                    </div>

                                    <div class="reg-div"></div>

                                    <div class="form-group row">
                                        <label for="cellphone" class="col-sm-4 col-form-label">26. Cell Phone Number</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="cellphone" class="form-control" v-model="model.MobilePhone" maxlength="30">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="phone" class="col-sm-4 col-form-label">27. Telephone Number</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="phone" class="form-control" v-model="model.Telephone" maxlength="20">
                                        </div>
                                    </div>

                                    <div class="reg-div"></div>

                                    <h2>Request visa details</h2>

                                    <div class="form-group row">
                                        <label for="daysofstay" class="col-sm-4 col-form-label">28. Proposed Length of Stay</label>
                                        <div class="col-sm-8">
                                            <label id="daysofstay" class="form-control disabled">{{model.LengthOfStay}}</label>

                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="travelreason" class="col-sm-4 col-form-label">29. Reason in full for wishing to travel to the Republic of Botswana</label>
                                        <div class="col-sm-8">
                                            <textarea rows="5" id="travelreason" class="form-control no-blue" v-model="model.TravelReason" maxlength="255"></textarea>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="arrivaldate" class="col-sm-4 col-form-label">30. Requested Validity Period of Visa</label>
                                        <div class="col-sm-8">
                                            <datepicker v-model="model.ArrivalDate"
                                                        :name="'arrivalDate'" id="arrivaldate"
                                                        class="form-control no-blue left "
                                                        :label="'Arrival Date'"
                                                        :placeholder="'Arrival Date...'"
                                                        :format="'dd/MM/yyyy'"
                                                        :required='true' />

                                            <datepicker v-model="model.DepartureDate"
                                                        :name="'departureDate'"
                                                        class="form-control no-blue right"
                                                        :label="'Departure Date'"
                                                        :placeholder="'Departure Date...'"
                                                        :format="'dd/MM/yyyy'"
                                                        :required='true' />
                                        </div>
                                    </div>

                                    <div class="reg-div"></div>

                                    <div class="form-group row">
                                        <label for="cash1" class="col-sm-4 col-form-label">31. Please indicate what money or cash (amount) will be at your disposal during your visit</label>
                                        <div class="col-sm-8">
                                            <div class="currency"><label class="curr-name">USD</label><input type="number" id="cash1" class="form-control left" min="0" v-model="moneyatdisposal[3].Sum" @keydown="isNotDot($event)"></div>
                                            <div class="currency"><label class="curr-name">ZAR</label><input type="number" id="cash2" class="form-control right" min="0" v-model="moneyatdisposal[1].Sum" @keydown="isNotDot($event)"></div>
                                            <div class="currency"><label class="curr-name">EUR</label><input type="number" id="cash3" class="form-control left" min="0" v-model="moneyatdisposal[2].Sum" @keydown="isNotDot($event)"></div>
                                            <div class="currency"><label class="curr-name">PUL</label><input type="number" id="cash4" class="form-control right" min="0" v-model="moneyatdisposal[0].Sum" @keydown="isNotDot($event)"></div>
                                        </div>
                                    </div>

                                    <div class="reg-div"></div>

                                    <div class="form-group row">
                                        <label for="collection" class="col-sm-4 col-form-label">32. Visa Collection Place</label>
                                        <div class="col-sm-8">
                                            <input type="text" id="collection" class="form-control" v-model="model.VisaCollectionPlace" maxlength="100">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="validuntil" class="col-sm-4 col-form-label">33. Valid Until</label>
                                        <div class="col-sm-8">
                                            <datepicker v-model="model.ValidUntil"
                                                        :name="'validUntil'" id="validuntil"
                                                        class="form-control no-blue"
                                                        :label="'Valid Until'"
                                                        :placeholder="'Valid Until...'"
                                                        :format="'dd/MM/yyyy'"
                                                        :required='true' />
                                        </div>
                                    </div>

                                    <div class="reg-div"></div>

                                    <div class="form-group row">
                                        <label for="email" class="col-sm-4 col-form-label">34. Declaration</label>
                                        <div class="col-sm-8">
                                            <input type="checkbox" class="form-check-input" id="declarationCheck" v-model="declaration">
                                            <label class="dec-label" for="exampleCheck1">I DECLARE that the above particulars given by me are true in substance and in fact</label>
                                        </div>
                                    </div>



                                    <!-- submit button -->
                                    <div class="form-group row">
                                        <div class="col-sm-12 submit-row top64 bt-100">
                                            <!--<router-link to="/images">-->
                                            <button type="submit" class="btn-submit">Upload Documents</button>
                                            <!--</router-link>-->
                                        </div>
                                    </div>


                                </form>
                            </div>

                            <!-- errors area -->
                            <div class="form-group row remark" v-if="errors.length">
                                <div class="col-sm-3">
                                    <div class="red-astr"></div>
                                    <div class="error">These fields contain errors</div>
                                </div>
                                <div class="col-sm-9">
                                    <div class="err-desc" v-for="error in errors">
                                        <span>{{ error }}</span>
                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
        </div>
        <div v-else class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                    <div class="left-links hrz-menu">
                        <label class="done">Registration</label>
                        <label class="done">Payment</label>
                        <label class="active" href="#">Visa Form</label>
                        <label class="passive" href="#">Documents</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 app">
                    <div class="reg-form">
                        <form class="k-form" @submit="handleSubmit" novalidate="true" autocomplete="off">
                            <h2>Application details</h2>

                            <div class="form-group row">
                                <label for="surname" class="col-sm-4 col-form-label">1. Surname</label>
                                <div class="col-sm-8">
                                    <input type="text" id="surname" class="form-control" v-model="model.LastName" @keypress="isLetterOfName($event)" maxlength="40">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="firstname" class="col-sm-4 col-form-label">2. First name</label>
                                <div class="col-sm-8">
                                    <input type="text" id="firstname" class="form-control" v-model="model.FirstName" @keypress="isLetterOfName($event)" maxlength="50">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="mddlename" class="col-sm-4 col-form-label">3. Miiddle name</label>
                                <div class="col-sm-8">
                                    <input type="text" id="mddlename" class="form-control" v-model="model.MiddleName" @keypress="isLetterOfName($event)" maxlength="40">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="prevname" class="col-sm-4 col-form-label">4. Previous/Maiden Surname</label>
                                <div class="col-sm-8">
                                    <input type="text" id="prevname" class="form-control" v-model="model.PrevName" @keypress="isLetterOfName($event)" maxlength="40">
                                </div>
                            </div>

                            <div class="reg-div"></div>

                            <div class="form-group row">
                                <label for="brthdate" class="col-sm-4 col-form-label">5. Date of birth</label>
                                <div class="col-sm-8">
                                    <datepicker v-model="model.BirthDate"
                                                :name="'dob'"
                                                class="form-control no-blue"
                                                :disabled="false"
                                                :min="minDOB" :max="getToday"
                                                :label="'Date of Birth'"
                                                :placeholder="'Date of Birth'"
                                                :format="'dd/MM/yyyy'"
                                                :required='true' />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="nationality" class="col-sm-4 col-form-label">6. Country of Birth</label>
                                <div class="col-sm-8">
                                    <kendo-combobox v-model="model.BirthCountry"
                                                    :data-source="countries"
                                                    class="form-control no-blue"
                                                    :name="'BirthCountry'"
                                                    id="BirthCountry"
                                                    :placeholder="'Select country of birth...'"
                                                    :data-text-field="'Description'"
                                                    :data-value-field="'Code'"
                                                    :filter="'contains'"
                                                    :required="true"
                                                    @cascade="onBirthCountryChanged"
                                                    :filter-fields="['Description']" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="birthplace" class="col-sm-4 col-form-label">7. Place of Birth</label>
                                <div class="col-sm-8">
                                    <input type="text" id="birthplace" class="form-control" v-model="model.BirthPlace" maxlength="50">
                                </div>
                            </div>

                            <div class="reg-div"></div>

                            <div class="form-group row">
                                <label for="passportnum" class="col-sm-4 col-form-label">8. Sex</label>
                                <div class="col-sm-8">
                                    <kendo-combobox v-model="model.Gender"
                                                    :data-source="genders"
                                                    :name="'Gender'"
                                                    id="gender"
                                                    class="form-control no-blue"
                                                    :placeholder="'Select gender...'"
                                                    :data-text-field="'Description'"
                                                    :data-value-field="'Code'"
                                                    :filter="'contains'"
                                                    :required="true"
                                                    @cascade="onGenderChanged"
                                                    :filter-fields="['Description']" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="passportnum" class="col-sm-4 col-form-label">9. Martial status</label>
                                <div class="col-sm-8">
                                    <kendo-combobox v-model="model.MaritalStatus"
                                                    :data-source="maritalStatuses"
                                                    :name="'Marital Status'"
                                                    id="martStatus"
                                                    class="form-control no-blue"
                                                    :placeholder="'Select marital status...'"
                                                    :data-text-field="'Description'"
                                                    :data-value-field="'Code'"
                                                    :filter="'contains'"
                                                    :required="true"
                                                    @cascade="onMaritalStatusChanged"
                                                    :filter-fields="['Description']" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="brthdate" class="col-sm-4 col-form-label">10. Nationality</label>
                                <div class="col-sm-8">
                                    <kendo-combobox v-model="model.Nationality"
                                                    :data-source="countries"
                                                    :name="'Country'"
                                                    id="nationality"
                                                    class="form-control no-blue"
                                                    :placeholder="'Nationality...'"
                                                    :data-text-field="'Description'"
                                                    :data-value-field="'Code'"
                                                    :filter="'contains'"
                                                    :required="true"
                                                    @cascade="onNationalityChanged"
                                                    :filter-fields="['Description']" />

                                </div>
                            </div>

                            <div class="reg-div"></div>

                            <div class="form-group row">
                                <label for="expirydate" class="col-sm-4 col-form-label">11. Type of visa required</label>
                                <div class="col-sm-2">
                                    <label id="brthdate" class="form-control disabled">{{strVisaCategory}}</label>
                                </div>
                                <label for="expirydate" class="col-sm-4 col-form-label">12. Number of Entries</label>
                                <div class="col-sm-2">
                                    <label id="brthdate" class="form-control disabled">{{strVisaType}}</label>
                                </div>
                                <p class="disabled">If you need to change the values of these fields, then you need to create a new application or contact the technical support service</p>
                            </div>

                            <div class="reg-div"></div>


                            <h3>Address in Country of Domicile</h3>

                            <div class="form-group row">
                                <label for="vsatype" class="col-sm-4 col-form-label">13. Country</label>
                                <div class="col-sm-8">
                                    <kendo-combobox v-model="address[0].Country"
                                                    :data-source="countries"
                                                    :name="'Domicile Country'"
                                                    id="domCountry"
                                                    class="form-control no-blue"
                                                    :placeholder="'Select country...'"
                                                    :data-text-field="'Description'"
                                                    :data-value-field="'Code'"
                                                    :filter="'contains'"
                                                    :required="true"
                                                    @cascade="onDomicileCountryChanged"
                                                    :filter-fields="['Description']" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="entries" class="col-sm-4 col-form-label">14. Town/Village</label>
                                <div class="col-sm-8">
                                    <input type="text" id="entries" class="form-control" v-model="address[0].Town" maxlength="100">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="entries" class="col-sm-4 col-form-label">15. Street/Ward</label>
                                <div class="col-sm-8">
                                    <input type="text" id="entries" class="form-control" v-model="address[0].Street" maxlength="20">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="email" class="col-sm-4 col-form-label">16. Plot/House No.</label>
                                <div class="col-sm-8">
                                    <input type="text" id="email" class="form-control" v-model="address[0].HouseNo" maxlength="20">
                                </div>
                            </div>

                            <div class="reg-div"></div>

                            <div class="form-group row">
                                <label for="email" class="col-sm-4 col-form-label">17. Occupation</label>
                                <div class="col-sm-8">
                                    <kendo-combobox v-model="model.Occupation"
                                                    :data-source="occupations"
                                                    :name="'Occupation'"
                                                    id="occupation"
                                                    class="form-control no-blue"
                                                    :placeholder="'Select occupation...'"
                                                    :data-text-field="'Description'"
                                                    :data-value-field="'Code'"
                                                    :filter="'contains'"
                                                    :required="true"
                                                    @cascade="onOccupationChanged"
                                                    :filter-fields="['Description']" />

                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="email" class="col-sm-4 col-form-label">18. Qualifications</label>
                                <div class="col-sm-8">

                                    <kendo-multiselect v-model="qualifications"
                                                       class="form-control"
                                                       :data-source="occupations"
                                                       :data-text-field="'Description'"
                                                       :data-value-field="'Code'"
                                                       :placeholder="'Select qualifications...'"
                                                       :filter="'contains'" />
                                </div>
                            </div>

                            <div class="reg-div"></div>

                            <h3>Particulars of travel documents which should be submitted with this Application</h3>

                            <div class="form-group row">
                                <label for="passno" class="col-sm-4 col-form-label">19. Number</label>
                                <div class="col-sm-8">
                                    <input type="text" id="passno" class="form-control upper" v-model="model.PassportNo" @keypress="isLetterOfPassportNumber($event)" maxlength="9">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="passplace" class="col-sm-4 col-form-label">20. Place of Issue</label>
                                <div class="col-sm-8">
                                    <input type="text" id="passplace" class="form-control" v-model="model.PassportIssuePlace" maxlength="25">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="brthdate" class="col-sm-4 col-form-label">21. Issue</label>
                                <div class="col-sm-8">
                                    <datepicker v-model="model.PassportIssueDate"
                                                :name="'passIssueDate'"
                                                class="form-control no-blue"
                                                :label="'Issue Date'"
                                                :placeholder="'Issue Date'"
                                                :format="'dd/MM/yyyy'"
                                                :required='true' />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="passExpiry" class="col-sm-4 col-form-label">22. Expiry</label>
                                <div class="col-sm-8">
                                    <datepicker v-model="model.PassportExpiryDate"
                                                :name="'passExpiryDate'"
                                                class="form-control no-blue"
                                                :min="getToday" :max="getTodayPlus20"
                                                :label="'Passport Expiry Date'"
                                                :placeholder="'Passport Expiry Date'"
                                                :format="'dd/MM/yyyy'"
                                                :required='true' />
                                </div>
                            </div>


                            <div class="reg-div"></div>

                            <h2>Host details</h2>
                            <h3>Host Address in Botswana</h3>

                            <div class="form-group row">
                                <label for="bwtown" class="col-sm-4 col-form-label">23. Town/Village</label>
                                <div class="col-sm-8">
                                    <kendo-combobox v-model="address[1].TownBW"
                                                    :data-source="towns"
                                                    :name="'Domicile Town'"
                                                    id="domTown"
                                                    class="form-control no-blue"
                                                    :placeholder="'Select town/village...'"
                                                    :data-text-field="'Description'"
                                                    :data-value-field="'Code'"
                                                    :filter="'contains'"
                                                    :required="true"
                                                    @cascade="onTownBWChanged"
                                                    :filter-fields="['Description']" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="bwstr" class="col-sm-4 col-form-label">24. Street/Ward</label>
                                <div class="col-sm-8">
                                    <input type="text" id="bwstr" class="form-control" v-model="address[1].Street" maxlength="20">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="bwhouseno" class="col-sm-4 col-form-label">25. Plot/House No.</label>
                                <div class="col-sm-8">
                                    <input type="text" id="bwhouseno" class="form-control" v-model="address[1].HouseNo" maxlength="20">
                                </div>
                            </div>

                            <div class="reg-div"></div>

                            <div class="form-group row">
                                <label for="cellphone" class="col-sm-4 col-form-label">26. Cell Phone Number</label>
                                <div class="col-sm-8">
                                    <input type="text" id="cellphone" class="form-control" v-model="model.MobilePhone" maxlength="30">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="phone" class="col-sm-4 col-form-label">27. Telephone Number</label>
                                <div class="col-sm-8">
                                    <input type="text" id="phone" class="form-control" v-model="model.Telephone" maxlength="20">
                                </div>
                            </div>

                            <div class="reg-div"></div>

                            <h2>Request visa details</h2>

                            <div class="form-group row">
                                <label for="daysofstay" class="col-sm-4 col-form-label">28. Proposed Length of Stay</label>
                                <div class="col-sm-8">
                                    <label id="daysofstay" class="form-control disabled">{{model.LengthOfStay}}</label>

                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="travelreason" class="col-sm-4 col-form-label">29. Reason in full for wishing to travel to the Republic of Botswana</label>
                                <div class="col-sm-8">
                                    <textarea rows="5" id="travelreason" class="form-control no-blue" v-model="model.TravelReason" maxlength="255"></textarea>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="arrivaldate" class="col-sm-4 col-form-label">30. Requested Validity Period of Visa</label>
                                <div class="col-sm-8">
                                    <datepicker v-model="model.ArrivalDate"
                                                :name="'arrivalDate'" id="arrivaldate"
                                                class="form-control no-blue left "
                                                :label="'Arrival Date'"
                                                :placeholder="'Arrival Date...'"
                                                :format="'dd/MM/yyyy'"
                                                :required='true' />

                                    <datepicker v-model="model.DepartureDate"
                                                :name="'departureDate'"
                                                class="form-control no-blue right"
                                                :label="'Departure Date'"
                                                :placeholder="'Departure Date...'"
                                                :format="'dd/MM/yyyy'"
                                                :required='true' />
                                </div>
                            </div>

                            <div class="reg-div"></div>

                            <div class="form-group row">
                                <label for="cash1" class="col-sm-4 col-form-label">31. Please indicate what money or cash (amount) will be at your disposal during your visit</label>
                                <div class="col-sm-8">
                                    <div class="currency"><label class="curr-name">USD</label><input type="number" id="cash1" class="form-control left" min="0" v-model="moneyatdisposal[3].Sum" @keydown="isNotDot($event)"></div>
                                    <div class="currency"><label class="curr-name">ZAR</label><input type="number" id="cash2" class="form-control right" min="0" v-model="moneyatdisposal[1].Sum" @keydown="isNotDot($event)"></div>
                                    <div class="currency"><label class="curr-name">EUR</label><input type="number" id="cash3" class="form-control left" min="0" v-model="moneyatdisposal[2].Sum" @keydown="isNotDot($event)"></div>
                                    <div class="currency"><label class="curr-name">PUL</label><input type="number" id="cash4" class="form-control right" min="0" v-model="moneyatdisposal[0].Sum" @keydown="isNotDot($event)"></div>
                                </div>
                            </div>

                            <div class="reg-div"></div>

                            <div class="form-group row">
                                <label for="collection" class="col-sm-4 col-form-label">32. Visa Collection Place</label>
                                <div class="col-sm-8">
                                    <input type="text" id="collection" class="form-control" v-model="model.VisaCollectionPlace" maxlength="100">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="validuntil" class="col-sm-4 col-form-label">33. Valid Until</label>
                                <div class="col-sm-8">
                                    <datepicker v-model="model.ValidUntil"
                                                :name="'validUntil'" id="validuntil"
                                                class="form-control no-blue"
                                                :label="'Valid Until'"
                                                :placeholder="'Valid Until...'"
                                                :format="'dd/MM/yyyy'"
                                                :required='true' />
                                </div>
                            </div>

                            <div class="reg-div"></div>

                            <div class="form-group row">
                                <label for="email" class="col-sm-4 col-form-label">34. Declaration</label>
                                <div class="col-sm-8">
                                    <input type="checkbox" class="form-check-input" id="declarationCheck" v-model="declaration">
                                    <label class="dec-label" for="exampleCheck1">I DECLARE that the above particulars given by me are true in substance and in fact</label>
                                </div>
                            </div>



                            <!-- submit button -->
                            <div class="form-group row">
                                <div class="col-sm-12 submit-row top64">
                                    <!--<router-link to="/images">-->
                                    <button type="submit" class="btn-submit">Upload Documents</button>
                                    <!--</router-link>-->
                                </div>
                            </div>


                        </form>
                    </div>

                    <!-- errors area -->
                    <div class="form-group row remark" v-if="errors.length">
                        <div class="col-sm-3">
                            <div class="red-astr"></div>
                            <div class="error">These fields contain errors</div>
                        </div>
                        <div class="col-sm-9">
                            <div class="err-desc" v-for="error in errors">
                                <span>{{ error }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopMenu from "./Menu";
    export default {
        components: {
            TopMenu
        },
        name: 'AppDetails',

        data: () => ({
            model: {},
            result: {},
            errors: [],
            address: [{}, {}],
            qualifications: [],
            moneyatdisposal: [{}, {}, {}, {}],

            formSaved: false,
            formValid: false,
            formForUpdate: false,
            declaration: false,
            paid: false,
            strBirthDate: '',
            strNationality: '',
            strVisaType: '',
            strVisaCategory: '',
            strPassExpiry: '',
            minDOB: new Date(1900, 1, 1),

            countries: [],
            genders: [],
            maritalStatuses: [],
            visatypes: [],
            visacategories: [],
            occupations: [],
            towns: [],
            windowWidth: window.innerWindow

        }),
        watch: {
            windowWidth(newWidth, oldWidth) {
                //console.log ("it changed to "+newWidth+" from " +oldWidth);
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        async mounted() {
            this.windowWidth = window.innerWidth;
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            }),
            this.model.ID = this.$cookie.get('eVisaAppID');
            //console.log('retrieved app num ' + this.model.ID);

            await this.getDictionaries();
            await this.getApplicationData();
            await this.checkPayment();
            if (this.paid == false)
                this.$router.push('PaymentNotOK');
        },

        computed: {
            appNum: function () {
                //return this.$store.state.appNum;
                return this.$cookie.get('eVisaAppID');
            },
            getToday: function () {
                var today = new Date();
                today.setHours(0, 0, 0);
                return today;
            },
            getTodayPlus20: function () {
                var today = new Date();
                var year = today.getFullYear();
                var month = today.getMonth();
                var day = today.getDate();
                var todayPlus20 = new Date(year + 20, month, day);
                return todayPlus20;
            }
        },

        methods: {
            onResize() {
                this.windowWidth = window.innerWidth
            },
            isLetterOfName(e) {
                let char = String.fromCharCode(e.keyCode);
                var regex = /[a-zA-Z-' ]/;
                if (regex.test(char))
                    return true;
                else e.preventDefault();
            },
            isLetterOfPassportNumber(e) {
                let char = String.fromCharCode(e.keyCode);
                var regex = /[a-zA-Z0-9]/;
                if (regex.test(char))
                    return true;
                else e.preventDefault();
            },
            isNotDot(e) {
                if (e.key === '.') {
                    event.preventDefault();
                }
            },

            onBirthCountryChanged(e) {
                var str = $('input[name ="BirthCountry_input"]').val();

                if (this.countries.find(x => x.Description === str) == null) {
                    this.cleanComboModel("BirthCountry_input", "BirthCountry", this.model.BirthCountry);
                }
            },
            onGenderChanged(e) {
                var str = $('input[name ="Gender_input"]').val();

                if (this.genders.find(x => x.Description === str) == null) {
                    this.cleanComboModel("Gender_input", "gender", this.model.Gender);
                }
            },
            onMaritalStatusChanged(e) {
                var str = $('input[name ="Marital Status_input"]').val();

                if (this.maritalStatuses.find(x => x.Description === str) == null) {
                    this.cleanComboModel("Marital Status_input", "martStatus", this.model.MaritalStatus);
                }
            },
            onNationalityChanged(e) {
                var str = $('input[name ="Country_input"]').val();

                if (this.countries.find(x => x.Description === str) == null) {
                    this.cleanComboModel("Country_input", "nationality", this.model.Nationality);
                }
            },
            onDomicileCountryChanged(e) {
                var str = $('input[name ="Domicile Country_input"]').val();

                if (this.countries.find(x => x.Description === str) == null) {
                    this.cleanComboModel("Domicile Country_input", "domCountry", this.address[0].Country);
                }
            },
            onOccupationChanged(e) {
                var str = $('input[name ="Occupation_input"]').val();

                if (this.occupations.find(x => x.Description === str) == null) {
                    this.cleanComboModel("Occupation_input", "occupation", this.model.Occupation);
                }
            },
            onTownBWChanged(e) {
                var str = $('input[name ="Domicile Town_input"]').val();

                if (this.towns.find(x => x.Description === str) == null) {
                    this.cleanComboModel("Domicile Town_input", "domTown", this.address[1].TownBW);
                }
            },
            cleanComboModel(name, id, prop) {
                $('input[name ="' + name + '"]').val("");
                $("#" + id).val("");
                prop = "";
            },
            async getDictionaries() {
               // console.log('A - getDictionaries');
                const d1 = this.getCountries();
                const d2 = this.getGenders();
                const d3 = this.getMaritalStatuses();
                const d4 = this.getOccupations();
                const d5 = this.getVisaTypes();
                const d6 = this.getVisaCategories();
                const d7 = this.getTowns();
                await Promise.all([d1, d2, d3, d4, d5, d6, d7]);
            },
            async getApplicationData() {
                //console.log('B - getAppData');
                const p1 = this.getApplication();
                const p2 = this.getAddresses();
                const p3 = this.getQualifications();
                const p4 = this.getMoneyAtDisposal();
                await Promise.all([p1, p2, p3, p4]);
            },

            async getCountries() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/dictionary/nationalities')
                    const data = await response.json()
                    this.countries = data
                    //console.log('1 - got countries');
                } catch (error) {
                    console.error(error)
                }
            },
            async  getGenders() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/dictionary/genders')
                    const data = await response.json()
                    this.genders = data
                    //console.log('2 - got genders')
                } catch (error) {
                    console.error(error)
                }
            },
            async getMaritalStatuses() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/dictionary/martialstatuses')
                    const data = await response.json()
                    this.maritalStatuses = data
                    //console.log('3 - got marital status')
                } catch (error) {
                    console.error(error)
                }
            },
            async getOccupations() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/dictionary/occupations')
                    const data = await response.json()
                    this.occupations = data
                    //console.log('4 - got occupations')
                } catch (error) {
                    console.error(error)
                }
            },
            async getVisaTypes() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/dictionary/visatypes')
                    const data = await response.json()
                    this.visatypes = data
                    //console.log('5 - visatypes')
                } catch (error) {
                    console.error(error)
                }
            },
            async getVisaCategories() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/dictionary/visacategories')
                    const data = await response.json()
                    this.visacategories = data
                    //console.log('6 - visacategories')
                } catch (error) {
                    console.error(error)
                }
            },
            async getTowns() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/dictionary/towns')
                    const data = await response.json()
                    this.towns = data
                    //console.log('7 - got towns')
                } catch (error) {
                    console.error(error)
                }
            },
            async getApplication() {
                try {

                    this.SetModelFields();

                    const response = await fetch(this.$apiip + '/api/v1/application/fetch', {
                        method: 'POST',
                        body: JSON.stringify(this.model),
                        headers: { 'Content-type': 'application/json; charset=UTF-8', 'cookie': this.$cookie.get('customCookie') }
                    })

                    const data = await response.json()
                    this.result = data
                    if (this.result.Status == 1) {
                        //console.log('getApplication - person info status 1');
                        data.Model.BirthDate = new Date(Date.parse(data.Model.BirthDate));
                        //console.log('b1 ' + data.Model.BirthDate);

                        data.Model.PassportExpiryDate = new Date(Date.parse(data.Model.PassportExpiryDate));
                        data.Model.ArrivalDate = new Date(Date.parse(data.Model.ArrivalDate));
                        data.Model.DepartureDate = new Date(Date.parse(data.Model.DepartureDate));
                        data.Model.PassportIssueDate = new Date(Date.parse(data.Model.PassportIssueDate));
                        data.Model.ValidUntil = new Date(Date.parse(data.Model.ValidUntil));

                        this.model = data.Model;
                        //console.log(this.model);

                        this.strVisaType = this.visatypes.find(item => item.Code == this.model.VisaType).Description;
                        this.strVisaCategory = this.visacategories.find(item => item.Code == this.model.VisaCategory).Description;

                        if (this.model.BirthDate.getTime() == 0)
                            this.model.BirthDate = null;

                        if (this.model.PassportIssueDate.getTime() == 0)
                            this.model.PassportIssueDate = null;

                        if (this.model.PassportExpiryDate.getTime() == 0)
                            this.model.PassportExpiryDate = null;

                        if (this.model.ArrivalDate.getTime() == 0)
                            this.model.ArrivalDate = null;

                        if (this.model.DepartureDate.getTime() == 0)
                            this.model.DepartureDate = null;

                        if (this.model.ValidUntil.getTime() == 0)
                            this.model.ValidUntil = null;

                    }
                } catch (error) {
                    console.error(error)
                }
            },
            async getAddresses() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/application/' + this.appNum + '/addresses')
                    const data = await response.json()
                    this.result = data
                    //console.log('getApplication addresses')
                    if (this.result.Status == 1) {
                        this.address = data.Addresses;
                    }
                }
                catch (error) {
                    console.error(error)
                }
            },
            async getQualifications() {
                try {
                    let response = await fetch(this.$apiip + '/api/v1/application/' + this.appNum + '/selectedQualifications')
                    let data = await response.json()
                    this.result = data
                    //console.log('getApplication selectedQualifications')
                    if (this.result.Status == 1) {
                        this.qualifications = data.Qualifications;
                    }
                }
                catch (error) {
                    console.error(error)
                }

            },
            async getMoneyAtDisposal() {
                try {
                    let response = await fetch(this.$apiip + '/api/v1/application/' + this.appNum + '/moneyatdisposals')
                    let data = await response.json()
                    //console.log('getApplication moneyatdisposals')
                    if (data.Status == 1) {
                        this.moneyatdisposal = data.MoneyAtDisposals;
                    }
                }
                catch (error) {
                    console.error(error)
                }
            },
            async checkPayment() {
                try {
                    let response = await fetch(this.$apiip + '/api/v1/payment/' + this.appNum + '/check')
                    let data = await response.json();
                    if (data.Status == 1)
                        this.paid = data.result;
                }
                catch (error) {
                    console.error(error)
                }
            },
            SetModelFields() {
                //console.log('setting fields')
                this.model.ID = this.appNum;
                this.model.LastName = '';
                this.model.FirstName = '';
                this.model.MiddleName = '';
                this.model.PrevName = '';
                this.model.MobilePhone = '';
                this.model.Telephone = '';

                this.model.PassportNo = '';
                this.model.PassportIssuePlace = '';
                this.model.PassportIssueDate = new Date(0); 
                this.model.PassportExpiryDate = new Date(0);

                this.model.BirthDate = new Date(0);
                this.model.BirthCountry = '';
                this.model.BirthPlace = '';

                this.model.Gender = '';
                this.model.MaritalStatus = '';
                this.model.Nationality = '';
                this.model.VisaType = '';
                this.model.VisaCategory = '';
                this.model.Occupation = '';

                this.model.LengthOfStay = 0;
                this.model.TravelReason = '';
                this.model.ArrivalDate = new Date(0);
                this.model.DepartureDate = new Date(0);
                this.model.VisaCollectionPlace = '';
                this.model.ValidUntil = new Date(0);
            },
            handleSubmit(event) {
                //console.log('handle submit');
                event.preventDefault();

                this.errors = [];
                this.validateData();
                // validate data
                //console.log("no of errors: " + this.errors.length);

                if (this.errors.length == 0)
                    this.save();
            },
            validateData() {
                // 1. last name validation
                if (!this.model.LastName)
                    this.errors.push('1. Surname is required');
                if (this.model.LastName.length > 40)
                    this.errors.push('1. Surname length must not exceed 50 characters');

                // 2. first name validation
                if (!this.model.FirstName)
                    this.errors.push('2. First Name is required');
                if (this.model.FirstName.length > 50)
                    this.errors.push('2. First name length must not exceed 40 characters');

                // 3. middle name validation
                if (this.model.MiddleName.length > 40)
                    this.errors.push('3. Middle name length must not exceed 40 characters');

                // 4. prev name validation
                if (this.model.PrevName.length > 40)
                    this.errors.push('4. Previous/Maiden name length must not exceed 40 characters');

                // 5. birth date validation
                if (!this.model.BirthDate)
                    this.errors.push('5. Birth date is required');
                if (this.model.BirthDate > Date.now())
                    this.errors.push('5. Birth date cannot be in the future');
                if (this.model.BirthDate < new Date(1900, 1, 1))
                    this.errors.push('5. Birth date is not logical, you are too old');

                // 6. country of birth validation
                if (!this.model.BirthCountry)
                    this.errors.push('6. Country of birth is required');

                // 7. place of birth validation
                if (!this.model.BirthPlace)
                    this.errors.push('7. Place of birth is required');

                // 8. gender validation
                if (!this.model.Gender)
                    this.errors.push('8. Sex is required');

                // 9. marital status validation
                if (!this.model.MaritalStatus)
                    this.errors.push('9. Marital status is required');

                // 10. nationality validation
                if (!this.model.Nationality)
                    this.errors.push('10. Nationality is required');

                // 13. address of domicile - country validation
                if (!this.address[0].Country)
                    this.errors.push('13. Address of domicile:country is required');
                // 14. address of domicile - town validation
                if (!this.address[0].Town)
                    this.errors.push('14. Address of domicile:town is required');
                // 15. address of domicile - street validation
                if (!this.address[0].Street)
                    this.errors.push('15. Address of domicile:street is required');
                // 16. address of domicile - house no validation
                if (!this.address[0].HouseNo)
                    this.errors.push('16. Address of domicile house no. is required');

                // 17. occupation validation
                if (!this.model.Occupation)
                    this.errors.push('17. Occupation is required');
                // 18. qualifications validation
                if (this.qualifications.length == 0)
                    this.errors.push('18. At least one qualification is required');

                // 19. passport no validation
                if (!this.model.PassportNo)
                    this.errors.push('19. Travel document number is required');

                // 20. passport place of issue validation
                if (!this.model.PassportIssuePlace)
                    this.errors.push('20. Travel document issue place is required');

                // 21. passport issue date validation
                if (this.model.PassportIssueDate <= this.model.BirthDate)
                    this.errors.push('21. Travel document issue date must be after date of birth');
                if (this.model.PassportIssueDate >= new Date().setHours(0,0,0))
                    this.errors.push('21. Travel document issue date must be before today');

                // 22. passport expiry date validation
                if (this.model.PassportExpiryDate <= this.model.PassportIssueDate)
                    this.errors.push('22. Travel document expiry date must be after issue date');
                if (this.model.PassportExpiryDate < new Date().setMonth(new Date().getMonth() + 6))
                    this.errors.push('22. Travel document expiration must be longer than 6 months');

                // 23. host address in Botswana - town validation
                if (!this.address[1].TownBW)
                    this.errors.push('23. Host address in Botswana:town is required');
                // 24. host address in Botswana - street validation
                if (!this.address[1].Street)
                    this.errors.push('24. Host address in Botswana:street is required');
                // 25. host address in Botswana - house number validation
                if (!this.address[1].HouseNo)
                    this.errors.push('25. Host address in Botswana:house number is required');

                // 26. cell phone number validation
                if (!this.model.MobilePhone)
                    this.errors.push('26. Mobile phone number is required');
                // 27. landline number validation
                if (!this.model.Telephone)
                    this.errors.push('27. Telphone number is required');

                // 29. reason for travel validation
                if (!this.model.TravelReason)
                    this.errors.push('29. Reason for travel is required');

                // 30. arrival&departure dates validation
                if (!this.model.ArrivalDate)
                    this.errors.push('30. Requested Validity Period of Visa - From is required');
                if (!this.model.DepartureDate)
                    this.errors.push('30. Requested Validity Period of Visa - To is required');
                if (this.model.ArrivalDate <= new Date().setHours(0,0,0))
                    this.errors.push('30. Requested Validity Period of Visa - From: must be after today');
                if (this.model.DepartureDate < this.model.ArrivalDate)
                    this.errors.push('30. Requested Validity Period of Visa - To date must be after From date');

                // 31. money-at-disposal validation
                if (this.moneyatdisposal[0].Sum == 0 && this.moneyatdisposal[1].Sum == 0 &&
                    this.moneyatdisposal[2].Sum == 0 && this.moneyatdisposal[3].Sum == 0)
                    this.errors.push('31. Money at disposal of at least one currency must be stated');

                // 32. visa collection place validation
                if (!this.model.VisaCollectionPlace)
                    this.errors.push('32. Visa collection place is required');

                // 33. valid until validation
                if (!this.model.ValidUntil)
                    this.errors.push('33. Collection place validity period is required');
                if (this.model.ValidUntil < new Date().setHours(0,0,0))
                    this.errors.push('33. Collection place validity period must be after today');

                // 34. declaration validation
                if (this.declaration == false)
                    this.errors.push('You must agree to the declaration of truthfulness');

            },
            async save() {
                try {
                    await this.SaveAppData();
                    this.SaveAddresses();
                    this.SaveMoneyAtDisposals();
                    this.SaveQualifications();
                    if (this.formSaved) {
                        this.$router.push('images');
                    }
                }
                catch (error) {
                    console.error(error);
                    this.errors.push(error);
                }
            },
            async SaveAppData() {
                this.formSaved = false
                const response = await fetch(this.$apiip + '/api/v1/application/any', {
                    method: 'PUT',
                    body: JSON.stringify(this.model),
                    headers: { 'Content-type': 'application/json; charset=UTF-8' },
                })
                const data = await response.json()

                this.result = data
                //console.log(this.result);
                if (this.result.Status == 1) {
                    this.formSaved = true
                } else if (this.result.Status == -1) {
                    throw "Saving app data failed";
                } else if (this.result.Status == -2) {
                    alert("Application is not paid");
                }
            },
            async SaveAddresses() {
                const response = await fetch(this.$apiip + '/api/v1/application/addresses', {
                    method: 'PUT',
                    body: JSON.stringify(this.address),
                    headers: { 'Content-type': 'application/json; charset=UTF-8' },
                })
                const data = await response.json()
                this.result = data
                if (this.result.Status == -1) {
                    throw "Saving addresses failed";
                }
            },
            async SaveMoneyAtDisposals() {
                const response = await fetch(this.$apiip + '/api/v1/application/moneyatdisposals', {
                    method: 'PUT',
                    body: JSON.stringify(this.moneyatdisposal),
                    headers: { 'Content-type': 'application/json; charset=UTF-8' },
                })
                const data = await response.json()
                this.result = data
                if (this.result.Status == -1) {
                    throw "Saving money-at-disposal failed";
                }
            },
            async SaveQualifications() {
                //console.log('qualifications: ' + this.qualifications);
                var qualificationModel = { AppId: this.appNum, Occupations: this.qualifications };
                //console.log('qualification model: ' + qualificationModel.Occupations);
                const response = await fetch(this.$apiip + '/api/v1/application/qualifications', {
                    method: 'PUT',
                    body: JSON.stringify(qualificationModel),
                    headers: { 'Content-type': 'application/json; charset=UTF-8' },
                })
                const data = await response.json()
                this.result = data
                if (this.result.Status == -1) {
                    throw "Saving qualifications failed";
                }
            }

        }
    }

</script>

<style scoped>
</style>